import * as angular from "angular";
import {IController} from "angular";
import {CommissionStatusType} from "../../types/commission-status.type";

export class CommissionStatusesMultiSelectCtrl implements IController {
  statuses: CommissionStatusType[];
  onChange: Function;

  public statusOptions: CommissionStatusType[] = Object.values(CommissionStatusType);

  constructor(private $mdSelect) {
  }

  $onInit() {

  };

  $onChanges(changes) {

  };

  reset() {
    this.onChange({statuses: angular.copy(this.statusOptions)});
    this.$mdSelect.hide();
  }

  cancel() {
    this.$mdSelect.hide();
  }

  select() {
    this.onChange({statuses: this.statuses?.length ? this.statuses : angular.copy(this.statusOptions)});
    this.$mdSelect.hide();
  }


}


angular
  .module('bringoz.admin.commons')
  .component('commissionStatusesMultiSelect', {
    bindings: {
      statuses: '<',
      ngPlaceholder: '<?',
      ngRequired: '<?',
      onChange: '&'
    },
    template: require('./commission-statuses-multi-select.html').default,
    controller: CommissionStatusesMultiSelectCtrl
  });
